import { render, staticRenderFns } from "./PageHeader.vue?vue&type=template&id=477843dc&scoped=true&"
import script from "./PageHeader.vue?vue&type=script&setup=true&lang=js&"
export * from "./PageHeader.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./PageHeader.vue?vue&type=style&index=0&id=477843dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477843dc",
  null
  
)

export default component.exports